module.exports = __webpack_public_path__ + "static/media/logo-eclos-brand-white.b0e10215.svg";